import { render, staticRenderFns } from "./resendEmail.vue?vue&type=template&id=9728b800&"
import script from "./resendEmail.vue?vue&type=script&lang=ts&"
export * from "./resendEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports